export enum features {
    ALLOW = 'allow',
    BENEFITS = "Benefits",
    COST_CENTERS = 'CostCenters',
    CURRENCY = "Currency",
    DASHBOARDS = "Dashboards",
    DOCUMENTS = "Documents",
    FORMS = "Forms",
    GLOBALIZATION = "Globalization",
    INTEGRATIONS = "Integrations",
    HOMEPAGE = "Homepage",
    NEWS_FEED = "NewsFeed",
    LISTS = "Lists",
    ORGANIZATION = "Organization",
    POSITIONS = "Positions",
    REPORTS = "Reports",
    SCHEDULES = "Schedules",
    SECURITY = "Security",
    SITE_SETTINGS = "SiteSettings",
    TALENT = "Talent",
    TIME_OFF = "Timeoff",
    TOIL = "Toil",
    TOIL_ADMINISTRATION = "ToilAdministration",
    WORK_LOCATIONS = "WorkLocations",
    WORK_ROTATIONS = "WorkRotations",
    // BANK_FEATURES_REPORT = "BankFeaturesReport",
    ORG_REPORT = "OrganizationReport",
    POSITIONS_REPORT = "PositionReport",
    // BASIC_EMPLOYEE_DETAILS_REPORT = "BasicEmployeeReport",
    // HEAD_COUNT_REPORT = "HeadCountReport",
    STATUTORY_HOLIDAYS = "StatutoryHolidays",
    COUNTRY_CONFIG = "Countries",
    PERFORMANCE = "Performance",
    PERFORMANCE_GOAL_PLANS = "PerformanceGoalPlans",
    PERFORMANCE_GOAL_TYPES = "PerformanceGoalTypes",
    PERFORMANCE_MANAGE_GOAL_PLANS = "PerformanceManageGoalPlans",
    PERFORMANCE_DIRECT_REPORTEE_GOALS = "PerformanceDirectReporteeGoals",
    PERFORMANCE_MANAGER_REVIEW_PLANS = "PerformanceManagerReviewPlans",
    PERFORMANCE_REVIEW_PLANS_ADMINISTRATION = "PerformanceReviewPlansAdministration",
    PERFORMANCE_MY_GOALS = "PerformanceMyGoals",
    ABSENCE_REPORT = "AbsenceReport",
    SITE_STYLING = "SiteStyling",
    BUSINESS_RULE_AUTOMATION = "RuleAutomations",
    LETTERS_ADMINISTRATION = "LettersAdministration",
    LETTERS_PUBLISHER = "LettersPublisher",
    IMPORTS = "Imports",
    DOCUMENTS_LIBRARY = "DocumentsLibrary",
    DOCUMENTS_LIBRARY_ADMINISTRATION = "DocumentsLibraryAdministration",
    DOCUMENTS_ACCESS = "DocumentsAccess",
    DOCUMENTS_PUBLISHER = "DocumentsPublisher",
    BUY_SELL = "BuySell",
    BUY_SELL_USER = "BuySellUser",
    BUY_SELL_ADMIN = "BuySellAdmin",
    TIME_OFF_MENU = "TimeoffMenu",
    QUICK_LINKS = "QuicklinkAdmin",
    ARTICLES = "ArticleAdmin",
    TAB_ABOUT_ME = "TabAboutMe",
    TAB_WHATS_NEW = "TabWhatsNew",
    TAB_ANNOUNCEMENTS = "TabAnnouncements",
    TAB_EMERGENCY_CONTACTS = "TabEmergencyContacts",
    TAB_FAMILY_DEPENDANTS = "TabFamilyDependants",
    TAB_HOME = "TabHome",
    TAB_PERSONAL_DETAILS = "TabPersonalDetails",
    TAB_QUICK_LINKS = "TabQuickLinks",
    TAB_SCHEDULE = "TabSchedule",
    TAB_TASKS = "TabTasks",
    TAB_TEAM_SCHEDULE = "TabTeamSchedule",
    TAB_TIME_OFF = "TabTimeOff",
    TAB_TOIL = "TabTOIL",
    TAB_TIME_OFF_GUIDES = "TabTimeOffGuides",
    TAB_PERFORMANCE = "TabPerformance",
    TAB_USER_TIME_OFF = "TabUserTimeOff",
    TAB_USER_BUY_SELL = "TabUserBuySell",
    TAB_GOAL_GUIDES = "TabGoalGuides",
    REPORTS_EMPLOYEES = "ReportsEmployees",
    REPORTS_ADMINISTRATOR = "ReportsAdministrator",
    REPORTS_PERFORMANCE = "ReportsPerformance",
    REPORTS_TERMINATIONS = "ReportsTerminations",
    REPORTS_TOIL = "ReportsTOIL",
    REPORTS_TIME_OFF = "ReportsTimeOff",
    REPORTS_SECURITY = "ReportsSecurity",
    REPORTS_CONFIGURATION = "ReportsConfiguration",
}
